module.exports = __webpack_public_path__ + "img/Hummingbird.85844ada.png";